const Information = (props) => (
  <svg {...props} height="1em" fill="none" viewBox="0 0 24 24" width="1em">
    <rect x="10" y="9" width="3" height="9" rx="1" fill="currentColor" />
    <circle cx="11.5" cy="5.5" r="1.5" fill="currentColor" />
  </svg>
);

export default Information;
